import React from 'react';
import dynamic from 'next/dynamic';
import withMainLayout from 'layouts/main';
import {pageMessagesProps} from 'helpers/i18n';
import {createTranslator, useTranslations} from 'next-intl';

// Content Components import
import HomeHero from '@/content/home/hero-section';
import TrustedByStrip from '@/content/home/trusted-by-strip';
import CustomerLogosCarousel from '@/content/home/customer-logos-carousel';
import WorkableAgentIntro from '@/content/home/workable-agent-intro';

// SEO metas
import OrgSchema from '@/schema';
import workableAi from '../messages/en/workableAi.json';
import homepage from '../messages/en/homepage.json';
import shared from '../messages/en/shared.json';

// Dynamic Content Components import
const TalentSourcingSection = dynamic(() => import('@/content/home/talent-sourcing'), {
  loading: () => null
});
const EmployeeManagementSection = dynamic(() => import('@/content/home/employee-management'), {
  loading: () => null
});
const AiSection = dynamic(() => import('@/content/home/ai-section'), {
  loading: () => null
});
const SupportSection = dynamic(() => import('@/content/home/support'), {
  loading: () => null
});
const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const IndexPage = () => {
  const t = useTranslations('homepage.prefooter');

  return (
    <>
      <HomeHero />
      <TrustedByStrip />
      <CustomerLogosCarousel />
      <WorkableAgentIntro />
      <TalentSourcingSection />
      <EmployeeManagementSection />
      <AiSection />
      <SupportSection />
      <PreFooter colLg={10} title={t('title')} subtitle={t('subtitle')} />
      <OrgSchema />
    </>
  );
};

const seoMetas = props => {
  const t = createTranslator({locale: props.locale, messages: props.messages});
  return {
    title: t('homepage.seo.title'),
    description: t('homepage.seo.description'),
    canonical: t('homepage.seo.canonical')
  };
};

export {IndexPage};

export const messagesForIntl = {shared, homepage, workableAi};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}

export default withMainLayout(IndexPage, seoMetas);
